import React from 'react';
import { connect } from 'react-redux';
import { map } from 'ramda';

import CompanyForm from '../../components/forms/CompanyForm';

import * as companyActions from '../../actions/entities/CompanyActions';
import * as modalActions from '../../actions/ModalActions';
import { fetchAccountGroups } from '../../actions/entities/AccountGroupsActions';
import { MODALS } from '../../constants/Constants';

const updateArr = (arr, item, add) => {
  const newArr = [...arr];
  const idx = arr.indexOf(item);
  if (add) {
    if (idx < 0) {
      newArr.push(item);
    }
  } else if (idx > -1) {
    newArr.splice(idx, 1);
  }
  return newArr;
};

class CompanyContainer extends React.Component {
  componentDidMount() {
    const {
      fetchCompany,
      fetchAccountGroups,
      resetCurrentCompany,
      match: {
        params: { companyId }
      }
    } = this.props;
    fetchAccountGroups();
    if (companyId) {
      fetchCompany(companyId);
    } else {
      resetCurrentCompany();
    }
  }

  handleDelete = () => {
    const {
      companies: { currentCompany }
    } = this.props;
    const { openModal } = this.props;
    openModal(MODALS.COMPANY_DELETE, { data: currentCompany });
  };

  handleSubmit = values => {
    const {
      companies: { currentCompany }
    } = this.props;
    const { updateCompany, createCompany } = this.props;
    const company = {
      features: [],
      ...currentCompany
    };
    company.name = values.name;
    company.slug = values.slug;
    company.primaryLanguage = values.primaryLanguage;
    // features
    company.features = updateArr(company.features, 'INTERPOSITION_SIM', values.interpositionSim);
    company.features = updateArr(company.features, 'NO_PASSWORD_FLOW', values.noPasswordFlow);
    // operators
    company.operators = map(
      ({ flagPositionCreation, flagProjectDataExport, flagDashboardChart, flagWeights, flagEmailInvitation, ...o }) => {
        const newOp = {
          password: 'dummyPassword',
          flags: [],
          ...o
        };
        newOp.flags = updateArr(newOp.flags, 'POSITION_CREATION', flagPositionCreation);
        newOp.flags = updateArr(newOp.flags, 'PROJECT_DATA_EXPORT', flagProjectDataExport);
        newOp.flags = updateArr(newOp.flags, 'DASHBOARD_CHART', flagDashboardChart);
        newOp.flags = updateArr(newOp.flags, 'WEIGHTS', flagWeights);
        newOp.flags = updateArr(newOp.flags, 'EMAIL_INVITATION', flagEmailInvitation);
        return newOp;
      },
      values.operators
    );
    // account group
    if (values.accountGroup) {
      company.accountGroup = { id: values.accountGroup };
    } else {
      company.accountGroup = null;
    }
    // contract plan
    if (
      values.profileLimitNumber > 0 ||
      !values.perfIndicatorIndependence ||
      !values.perfIndicatorSelfStylization ||
      !values.featureSkillsDescription ||
      !values.featureRecommendations ||
      !values.featureProfilePrint ||
      values.operatorLimit > 0 ||
      values.teaseDashboardChart ||
      values.eapiEnabled ||
      values.contractPlanType ||
      values.modeSourcing ||
      values.modeRecruitment ||
      values.modeDevelopment ||
      values.modeTeams ||
      values.isVendor ||
      !values.initiativeTypesWBI ||
      !values.initiativeTypesCustom ||
      !values.initiativeTypesEngagementIndex
    ) {
      const contractPlan = { ...company.contractPlan };
      // plan type
      if (values.contractPlanType) {
        contractPlan.type = values.contractPlanType;
      }
      // profile limit
      if (values.profileLimitNumber > 0) {
        contractPlan.profileLimit = {
          number: values.profileLimitNumber,
          global: !values.profileLimitPerPosition,
          resetPeriod: values.profileLimitReset ? values.profileLimitPeriod : null,
          expiration: values.profileLimitExpirationEnabled
            ? values.profileLimitExpiration && values.profileLimitExpiration.getTime()
            : null
        };
      } else {
        contractPlan.profileLimit = null;
      }
      // disabled performance indicators
      contractPlan.disabledPerformanceIndicators = [];
      contractPlan.disabledPerformanceIndicators = updateArr(
        contractPlan.disabledPerformanceIndicators,
        'independence',
        !values.perfIndicatorIndependence
      );
      contractPlan.disabledPerformanceIndicators = updateArr(
        contractPlan.disabledPerformanceIndicators,
        'selfStylization',
        !values.perfIndicatorSelfStylization
      );
      // disabled features
      contractPlan.disabledFeatures = [];
      contractPlan.disabledFeatures = updateArr(
        contractPlan.disabledFeatures,
        'SKILLS_DESCRIPTION',
        !values.featureSkillsDescription
      );
      contractPlan.disabledFeatures = updateArr(
        contractPlan.disabledFeatures,
        'RECOMMENDATIONS',
        !values.featureRecommendations
      );
      contractPlan.disabledFeatures = updateArr(
        contractPlan.disabledFeatures,
        'PROFILE_PRINT',
        !values.featureProfilePrint
      );
      // operator limit
      if (values.operatorLimit > 0) {
        contractPlan.operatorLimit = values.operatorLimit;
      } else {
        contractPlan.operatorLimit = null;
      }
      // tease dashboard chart
      contractPlan.teaseDashboardChart = values.teaseDashboardChart;
      contractPlan.eapiEnabled = values.eapiEnabled;
      // modes
      contractPlan.modes = [];
      if (values.modeSourcing) {
        contractPlan.modes.push('SOURCING');
      }
      if (values.modeRecruitment) {
        contractPlan.modes.push('RECRUITMENT');
      }
      if (values.modeDevelopment) {
        contractPlan.modes.push('DEVELOPMENT');
      }
      if (values.modeTeams) {
        contractPlan.modes.push('TEAMS');
      }
      //
      contractPlan.vendor = values.isVendor;
      // initiative types
      contractPlan.disabledInitiativeTypes = [];
      if (!values.initiativeTypesWBI) {
        contractPlan.disabledInitiativeTypes.push('WELL_BEING_INDEX');
      }
      if (!values.initiativeTypesCustom) {
        contractPlan.disabledInitiativeTypes.push('CUSTOM');
      }
      if (!values.initiativeTypesEngagementIndex) {
        contractPlan.disabledInitiativeTypes.push('ENGAGEMENT_INDEX');
      }
      company.contractPlan = contractPlan;
    } else {
      company.contractPlan = null;
    }
    // data
    const oldData = currentCompany.data || {};
    company.data = {
      ...oldData,
      participantAccess: {
        ...oldData.participantAccess,
        admin: values.adminAccessParticipantData
      },
      internalTags: values.internalTags,
      posterType: values.posterType,
      promptContext: {
            ...oldData.promptContext,
            en: {
              ...(oldData.promptContext && oldData.promptContext.en),
              echoPulse: values.echoPulsePromptContextEN
            }
          }
    };

    if (company.id) {
      updateCompany(company, false);
    } else {
      createCompany(company);
    }
  };

  render() {
    const {
      companies: { currentCompany },
      loading
    } = this.props;
    const { impersonateDashboardUser } = this.props;
    if (!currentCompany || loading) {
      return null;
    }
    return (
      <div className="flex flex1">
        <CompanyForm
          onSubmit={this.handleSubmit}
          onDelete={this.handleDelete}
          impersonateDashboardUser={impersonateDashboardUser}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ entities: { companies }, loader: { loading } }) => ({ companies, loading });

export default connect(mapStateToProps, { ...companyActions, ...modalActions, fetchAccountGroups })(CompanyContainer);



// WEBPACK FOOTER //
// ./src/containers/private/CompanyContainer.js